module.exports = __webpack_public_path__ + "f6c444b0f457560719f4c6b471eece53.pdf";